import * as React from "react"
import { cn } from "@/lib/utils"

const StatusDot = React.forwardRef(({ className, status = "ok", ...props }, ref) => {
  const statusColors = {
    ok: "bg-success",
    error: "bg-destructive",
    warning: "bg-warning",
    info: "bg-info",
    pending: "bg-muted-foreground animate-pulse",
    offline: "bg-muted-foreground",
  }

  return (
    <span
      ref={ref}
      className={cn(
        "inline-block w-2 h-2 rounded-full",
        statusColors[status] || statusColors.info,
        className
      )}
      {...props}
    />
  )
})
StatusDot.displayName = "StatusDot"

const StatusBadge = React.forwardRef(({ className, status = "ok", label, ...props }, ref) => {
  const statusConfig = {
    ok: { color: "bg-success/10 text-success border-success/20", label: "Online" },
    error: { color: "bg-destructive/10 text-destructive border-destructive/20", label: "Error" },
    warning: { color: "bg-warning/10 text-warning border-warning/20", label: "Warning" },
    info: { color: "bg-info/10 text-info border-info/20", label: "Info" },
    pending: { color: "bg-muted text-muted-foreground border-border", label: "Pending" },
    offline: { color: "bg-muted text-muted-foreground border-border", label: "Offline" },
  }

  const config = statusConfig[status] || statusConfig.info

  return (
    <span
      ref={ref}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium",
        config.color,
        className
      )}
      {...props}
    >
      <StatusDot status={status} />
      {label || config.label}
    </span>
  )
})
StatusBadge.displayName = "StatusBadge"

export { StatusDot, StatusBadge }
